<template>
  <div>
    <div class="chunk-similar">
      <div
        v-for="(entity, index) in this.entity"
        :key="index"
        :id="index"
        class="chunk-text"
      >
        <strong>{{ entity.name }}</strong> <br />
        <div class="entity-text">
          {{ entity.text }}
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "EntityCard",
  props: {
    entity: Array,
  },
};
</script>

<style scoped>
.chunk-similar {
  background-color: rgba(30, 30, 30, 1);
  border-radius: 8px;
  padding: 15px 22px 15px 22px;
  transition: 0.3s ease-in-out;
}
.chunk-text {
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 21px;
  color: rgb(255, 255, 255);
  transition: 0.3s ease-in-out;
  border-radius: 8px;
  padding: 4px 10px;
  margin-top: 10px;
  margin-bottom: 10px;
  width: fit-content;
}

.entity-text {
  padding-top: 5px;
  color: rgb(204, 204, 204);
}

.left-marker {
  grid-column-start: 1;
  grid-column-end: 2;
  justify-items: start;
  width: 3px;
  height: 100%;
  border-radius: 1.5px;
}

.wolfgang-kaleck-chunk {
  background-color: rgba(3, 149, 169, 1);
  opacity: 1;
  transition: 0.3s ease-in-out;
}
</style>